import { InfoIcon } from 'assets/icons';
import CustomLink from 'components/shared/CustomLink';
import styles from './HeroConsentDisclaimer.module.css';

export const HeroConsentDisclaimer = ({
  className,
  align,
  padding,
  light,
  icon,
}: {
  className?: string;
  align?: 'center' | 'flex-start' | 'flex-end';
  padding?: boolean;
  light?: boolean;
  icon?: boolean;
}) => {
  return (
    <div
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      style={
        {
          '--primary-color': light ? '#00000077' : '#000000',
          '--hcd-padding': padding ? '24px' : '0',
          '--hcd-text-align': align ?? 'left',
          '--hcd-justify': align ?? 'flex-start',
        } as React.CSSProperties
      }
    >
      {icon === true ? (
        <InfoIcon fill={light ? '#00000077' : '#000000'} />
      ) : null}
      <p>
        *Heroes Special Pricing Verification: By purchasing, you consent to
        provide ID or proof of eligibility if requested. We collect only
        what&apos;s needed, delete it after use, and handle your data per
        applicable privacy laws. Please review our{' '}
        <CustomLink href="/privacyPolicy" target="_blank">
          Privacy Policy
        </CustomLink>{' '}
        for details.
      </p>
      {/* <p>
        By purchasing, you consent to provide ID or proof of eligibility if
        requested. We collect only what&apos;s needed, delete it after use,
        and handle your data per applicable privacy laws. Please review our{' '}
        <Link href="/privacyPolicy" target="_blank">
          Privacy Policy
        </Link>{' '}
        for details.
      </p> */}
    </div>
  );
};
